import createCache from '@emotion/cache';

// Create emotion cache for client-side with insertion point for consistent SSR/client style order
export default function createEmotionCache() {
  // On client-side, find the insertion point meta tag
  const insertionPoint =
    typeof document !== 'undefined'
      ? (document.querySelector(
          'meta[name="emotion-insertion-point"]',
        ) as HTMLMetaElement)
      : undefined;

  return createCache({
    key: 'css',
    insertionPoint,
    prepend: true,
    // MUI v6 + Emotion 11: align SSR extraction with client style serialization.
    compat: true,
  } as Parameters<typeof createCache>[0]);
}
